import React, { useContext, useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';

import { Signature } from '../../types/user';
import { Actions, Categories, Labels } from '../../types/gtm';
import { DeleteAccountContext } from '.';
import Title from '../../components/Title';
import { ItemWebSignature } from './components/ItemWebSignature';

import { DivContent, DivHeader, DivBox } from './styles';
import { separateSubscriptionsByProvider } from '../../util/subscription';
import { ItemEditoraSignature } from './components/ItemEditoraSignature';

const SalesForce = 'SalesForce';

const DeleteSubscriptionsDetails = () => {
  const { subscriptionData } = useContext(DeleteAccountContext);
  const { user } = useAuth();
  const [webSubscriptions, setWebSubscriptions] = useState<Signature[]>([]);
  const [editoraSubscriptions, setEditoraSubscriptions] = useState<Signature[]>(
    [],
  );

  window.dataLayer = window.dataLayer || [];

  useEffect(() => {
    if (subscriptionData.signatures.length > 0) {
      const { salesForceSignatures, editoraSignatures } =
        separateSubscriptionsByProvider(subscriptionData, SalesForce);

      setWebSubscriptions(salesForceSignatures);
      setEditoraSubscriptions(editoraSignatures);
    }
  }, [subscriptionData]);

  useEffect(() => {
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: Categories.DeleteAccount,
      event_action: Actions.Pageview,
      event_label: Labels.DeleteAccountSubscriptionsDetailsPage,
      bd_suser_code: user?.globoId,
    });
  }, [user]);

  return (
    <>
      <DivHeader>
        <Title>Assinaturas</Title>
        <p>
          Todas as assinaturas vinculadas à sua conta devem ser{' '}
          <strong>canceladas</strong>. <br />
          Confira a seguir quais são as suas assinaturas ativas:
        </p>
      </DivHeader>
      <DivBox>
        <DivContent className="mcv3-card">
          {webSubscriptions.length > 0 && (
            <ItemWebSignature
              signatures={webSubscriptions}
              globoId={user.globoId}
            />
          )}

          {editoraSubscriptions.length > 0 && (
            <ItemEditoraSignature signatures={editoraSubscriptions} />
          )}
        </DivContent>
      </DivBox>
    </>
  );
};

export default DeleteSubscriptionsDetails;
